import React, { useEffect, useState } from 'react'
import "./CSS/PLC.css"
import { connect } from 'react-redux'
import Store from '../Store/Store'
import { add_plc, edit_plc, remove_plc, remove_points, set_plc } from '../Action/Action'

const PLC = (props) => {

  const [alert, Setalert] = useState("")


  const [plc_list, Set_plc_list] = useState(props.plc)

  const [_ucer_id, Set_ucer_id] = useState(() => {
    var ucer = sessionStorage.getItem("ucer_id")
    if (ucer) {
      ucer = JSON.parse(ucer)
    }
    return ucer
  })

  const [inp1, Setinp1] = useState("")
  const [inp2, Setinp2] = useState("")
  const [inp3, Setinp3] = useState(0)

  const [isChecked, setIsChecked] = useState(false);

  const [edit_id, Set_edit_id] = useState(null)
  const [edit_ischecked, Set_edit_ischecked] = useState(isChecked)
  const [edit_name, Set_edit_name] = useState(null)
  const [edit_slot, Set_edit_slot] = useState(null)
  const [edit_address, Set_edit_address] = useState(null)
  const [edit_type, Set_edit_type] = useState(1)



  const [plc_type, Setplc_type] = useState("")
  const [plc_module, SetPlcModule] = useState("")


  const onEditFormSubmit = async (e) => {
    e.preventDefault()
    var obj = {
      "plcName": edit_name,
      "plcAddress": edit_address,
      "plcType": Number(edit_type),
      "slotNo": Number(edit_slot),
      "moduleId": 1,
      "isActive": edit_ischecked ? true : false,
      "plcId": Number(edit_id),
      "companyId": Number(_ucer_id)

    }

    try {
      const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/EditPlc", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        body: JSON.stringify(obj)
      }
      )

      const response = await request.json()

      // Update Redux store with the latest list from API
      await Store.dispatch(set_plc(response))

      let alert_box = document.querySelector("#alert-box");
      alert_box.classList.add("alert_add");
      alert_box.classList.add("alert-box-active")
      Setalert(`${edit_name} was updated successfully`)

      setTimeout(() => {
        alert_box.classList.remove("alert_add")
        alert_box.classList.remove("alert-box-active")
        Setalert("")
      }, 4000);

    } catch (err) {
      console.log(err);
    }



    var pop_up = document.querySelector(".edit_plc_pop_up")
    var plc_seciton = document.querySelector("section.plc_section")
    if (plc_seciton.classList.contains("plc_section_dark")) plc_seciton.classList.remove("plc_section_dark")

    if (pop_up.classList.contains("edit_plc_pop_up_active")) {
      pop_up.classList.remove("edit_plc_pop_up_active")
    }
  }

  useEffect(() => {

    var ucer_id = sessionStorage.getItem("ucer_id")

    if (ucer_id) {
      ucer_id = JSON.parse(ucer_id)
    } else {
      ucer_id = null
    }

    const compoenntDidMount = async () => {
      try {
        const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/GetPlcList", {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json"
          },
          body: JSON.stringify({
            "companyId": _ucer_id
          })
        }
        )

        const response = await request.json()

        console.log(response);

        Set_plc_list(response)

        await Store.dispatch(set_plc(response))

      } catch (err) {
        console.log(err);
      }

    }

    compoenntDidMount()
  }, [])



  const open_add_pop_up = () => {
    var pop_up = document.querySelector(".add_plc_pop_up")

    var plc_seciton = document.querySelector("section.plc_section")

    if (!plc_seciton.classList.contains("plc_section_dark")) plc_seciton.classList.add("plc_section_dark")

    if (!pop_up.classList.contains("add_plc_pop_up_active")) {
      pop_up.classList.add("add_plc_pop_up_active")
    }

  }
  const open_edit_pop_up = (plcItem) => {
    Set_edit_id(plcItem.plcId)
    Set_edit_name(plcItem.plcName)
    Set_edit_slot(plcItem.slotNo)
    Set_edit_address(plcItem.plcAddress)
    Set_edit_type(plcItem.plcType || 0)
    Set_edit_ischecked(plcItem.isActive)
    var pop_up = document.querySelector(".edit_plc_pop_up")
    var plc_seciton = document.querySelector("section.plc_section")

    if (!plc_seciton.classList.contains("plc_section_dark")) plc_seciton.classList.add("plc_section_dark")

    if (!pop_up.classList.contains("edit_plc_pop_up_active")) {
      pop_up.classList.add("edit_plc_pop_up_active")
    }

  }

  const close_add_pop_up = () => {
    Set_edit_id(null)
    Set_edit_name(null)
    Set_edit_slot(null)
    Set_edit_address(null)
    var pop_up = document.querySelector(".add_plc_pop_up")
    var plc_seciton = document.querySelector("section.plc_section")
    if (plc_seciton.classList.contains("plc_section_dark")) plc_seciton.classList.remove("plc_section_dark")

    if (pop_up.classList.contains("add_plc_pop_up_active")) {
      pop_up.classList.remove("add_plc_pop_up_active")
    }

  }
  const close_edit_pop_up = () => {
    var pop_up = document.querySelector(".edit_plc_pop_up")
    var plc_seciton = document.querySelector("section.plc_section")
    if (plc_seciton.classList.contains("plc_section_dark")) plc_seciton.classList.remove("plc_section_dark")

    if (pop_up.classList.contains("edit_plc_pop_up_active")) {
      pop_up.classList.remove("edit_plc_pop_up_active")
    }

  }

  const OnChangeinp1 = (e) => {
    Setinp1(e.target.value)
  }
  const OnChangeinp2 = (e) => {
    Setinp2(e.target.value)
  }
  const OnChangeinp3 = (e) => {
    Setinp3(e.target.value)
  }
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const OnChangeinp1_1 = (e) => {
    Set_edit_name(e.target.value)
  }
  const OnChangeinp2_2 = (e) => {
    Set_edit_address(e.target.value)
  }
  const OnChangeinp3_3 = (e) => {
    Set_edit_slot(e.target.value)
  }
  const handleCheckboxChange_2 = () => {
    Set_edit_ischecked(!edit_ischecked);
  };



  const deleteRow = async (e) => {

    var plcId_ = e.target.parentElement.parentElement.id
    var plcName_ = e.target.parentElement.parentElement.firstElementChild.textContent

    plcId_ = Number(plcId_);

    if (!window.confirm(`Are you sure you want to delete "${plcName_}"?`)) {
      return;
    }

    const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/DeletePlc", {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      method: "POST",
      body: JSON.stringify({
        "plcId": plcId_
      })
    })

    if (request.status === 200) {

      await Store.dispatch(remove_plc(Number(plcId_)))

      let alert_box = document.querySelector("#alert-box");
      alert_box.classList.add("alert_delete");
      alert_box.classList.add("alert-box-active")
      Setalert(`${plcName_} was deleted successfully`)

      setTimeout(() => {
        alert_box.classList.remove("alert_delete")
        alert_box.classList.remove("alert-box-active")
        Setalert("")
      }, 4000);
    }

  }





  const OnFormSubmit = async e => {
    e.preventDefault()

    var pop_up = document.querySelector(".add_plc_pop_up")
    var plc_seciton = document.querySelector("section.plc_section")
    if (plc_seciton.classList.contains("plc_section_dark")) plc_seciton.classList.remove("plc_section_dark")

    if (pop_up.classList.contains("add_plc_pop_up_active")) {
      pop_up.classList.remove("add_plc_pop_up_active")
    }

    try {
      const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/AddPlc", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Accept": "application/json"
        },
        body: JSON.stringify({
          "plcName": inp1,
          "plcAddress": inp2,
          "plcType": Number(plc_type),
          "slotNo": Number(inp3),
          "moduleId": 1,
          "isActive": isChecked ? true : false,
          "companyId": Number(_ucer_id)
        }
        )
      })


      if (request.status === 200) {
        const response = await request.json()
        // Update Redux store with the latest list from API
        await Store.dispatch(set_plc(response))

        let alert_box = document.querySelector("#alert-box");
        alert_box.classList.add("alert_add");
        alert_box.classList.add("alert-box-active")
        Setalert(`${inp1} was added successfully`)

        setTimeout(() => {
          alert_box.classList.remove("alert_add")
          alert_box.classList.remove("alert-box-active")
          Setalert("")
        }, 4000);
      }
    } catch (err) {
      console.log(err);
    } finally {
      Setinp1("")
      Setinp2("")
      Setinp3(0)
      Setplc_type("")
      setIsChecked(false)
    }

  }


  return (
    <>
      <div className='' id="alert-box">{alert}</div>

      <div className="add_plc_pop_up">
        <header>Add New PLC</header>
        <form onSubmit={OnFormSubmit}>
          <div className="input-group">Name <input onChange={OnChangeinp1} value={inp1} type="text" placeholder='plc name' /></div>
          <div className="input-group">Address <input pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$" minlength="7" maxlength="15" size="15" onChange={OnChangeinp2} value={inp2} type="text" placeholder='plc address' /></div>
          <div className="input-group">Slot <input disabled={true} value={inp3} type="number" /></div>
          <div className="input-group">Type
            <select onChange={(e) => {
              const selectedValue = Number(e.target.value);
              Setplc_type(selectedValue);
              if (selectedValue === 1) {
                Setinp3(2)
              } else {
                Setinp3(0)
              }
            }} id="add_new_plc_select_type" value={plc_type}>
              <option value="0">Choose</option>
              <option value={1}>Siemens</option>
              <option value={2}>Pilz</option>
              <option value={3}>Delta</option>
              <option value={4}>BACnet</option>
              <option value={5}>Virtual</option>
            </select>
          </div>
          <div className="input-group">Active <input checked={isChecked} onChange={handleCheckboxChange} type="checkbox" name="" id="checkbox_inp_id" /></div>
          <div className="input-group">Module <select id="add_new_plc_select_module"></select></div>
          <div className="btn-group"><button type='button' onClick={close_add_pop_up}>Cancel <i class="fa-solid fa-ban"></i></button><button>Add <i class="fa-solid fa-check"></i></button></div>
        </form>
      </div>
      <div className="edit_plc_pop_up">
        <header>Edit PLC</header>
        <form onSubmit={onEditFormSubmit}>
          <div className="input-group">Name <input onChange={OnChangeinp1_1} value={edit_name} type="text" placeholder='plc name' /></div>
          <div className="input-group">Address <input pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$" minlength="7" maxlength="15" size="15" onChange={OnChangeinp2_2} value={edit_address} type="text" placeholder='plc address' /></div>
          <div className="input-group">Slot <input disabled={true} onChange={OnChangeinp3_3} value={edit_slot} type="number" /></div>
          <div className="input-group">Type
            <select onChange={(e) => {
              const selectedValue = Number(e.target.value);
              Set_edit_type(selectedValue);
              if (selectedValue === 1) {
                Set_edit_slot(2)
              } else {
                Set_edit_slot(0)
              }
            }} id="edit_new_plc_select_type" value={edit_type}>
              <option value="0">Choose</option>
              <option value={1}>Siemens</option>
              <option value={2}>Pilz</option>
              <option value={3}>Delta</option>
              <option value={4}>BACnet</option>
              <option value={5}>Virtual</option>
            </select>
          </div>
          <div className="input-group">Active <input checked={edit_ischecked ? true : false} onChange={handleCheckboxChange_2} type="checkbox" name="" id="checkbox_inp_id" /></div>
          <div className="input-group">Module <select id="add_new_plc_select_module"></select></div>
          <div className="btn-group"><button type='button' onClick={close_edit_pop_up}>Cancel <i class="fa-solid fa-ban"></i></button><button>Update <i class="fa-solid fa-check"></i></button></div>
        </form>
      </div>
      <section className="plc_section">
        <h1><div onClick={open_add_pop_up}>New PLC <i className="fa fa-plus"></i></div>  </h1>
        <div className="table_plc_top">
          <div className="row">
            <span>PLC Name</span>
            <span>PLC Address</span>
            <span>Slot Number</span>
            <span>PLC Type</span>
            <span>Module Name</span>
            <span>Is Active</span>
            <span style={{ opacity: "0" }}></span>
          </div>
          <div className="row">
            <span><input type="text" /><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><input type="text" /><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><input type="text" /><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><input type="text" /><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span><input type="text" /><i style={{ marginLeft: "10px", marginTop: "4px" }} class="fa-solid fa-filter"></i></span>
            <span style={{ display: "flex", justifyContent: "space-evenly" }}><input type="checkbox" />/<input style={{ marginLeft: "-8px" }} type='checkbox' className='true_checkbox' /></span>
            <span></span>

          </div>
        </div>
        <div className="table_plc_bottom">
          {props.plc ? props.plc.map((item, index) => {
            const plcTypeNames = {0: '-', 1: 'Siemens', 2: 'Pilz', 3: 'Delta', 4: 'BACnet', 5: 'Virtual'};
            return <div id={item.plcId} key={item.plcId} className="row">
              <span>{item.plcName}</span>
              <span>{item.plcAddress}</span>
              <span>{item.slotNo}</span>
              <span>{plcTypeNames[item.plcType] || item.plcType}</span>
              <span>{item.plcModule}</span>
              <span>{item.isActive === true ? <input type='checkbox' checked readOnly className='true_checkbox' /> : <input type='checkbox' readOnly className='false_checkbox' />}</span>
              <span className='edit_btns_plc'><button onClick={() => open_edit_pop_up(item)}>Edit</button><button onClick={deleteRow}>Delete</button></span>
            </div>
          }) : ""}
        </div>
      </section>
    </>
  )
}

const MapStateToProps = (state) => {
  return {
    plc: state.project_reducer.plc
  }
}

export default connect(MapStateToProps)(PLC)